import React, { Component } from "react";
import logout from "./Logout";
import { Link } from "react-router-dom";
import $ from "jquery";
import {
  ReCaptcha,
  loadReCaptcha as fetchReCaptchaFromReactRecaptcha,
} from "react-recaptcha-google";
import { ToastContainer, toast } from "react-toastify";
import CookieConsentModal from "./CookieConsentModal";

class LoginPage extends Component {
  constructor() {
    super();
    this.state = {
      errors: {},
      resetPwdMsg: false,
      loginVal: false,
      showPwd: false,
      createac: false,
      fields: {},
      recaptchaVerified: false,
      expiryTime: null,
      showLoader: false,
      recaptchaLoaded: false,
    };
    this._isMounted = false;
  }

  componentDidMount = () => {
    this._isMounted = true;
    fetchReCaptchaFromReactRecaptcha();

    const intervalId = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.render) {
        if (this._isMounted) {
          this.setState({ recaptchaLoaded: true });
        }
        clearInterval(intervalId);
      }
    }, 200); // Check every 200ms

    if (this.captcha) {
      this.captcha.reset();
    }

    localStorage.clear();
    if (this.props.location.state !== undefined) {
      this.setState({ resetPwdMsg: this.props.location.state.resetPwdMsg });
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  onLoadRecaptcha = () => {
    if (this.captcha) {
      this.captcha.reset();
    }
  };

  verifyCallbackApi = (response) => {
    var thisController = this;
  
    $.ajax({
      url: "/my-jeeva-api/verify-recaptcha",
      type: "POST",
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
      },
      data: { response: response },
      contentType: false,
      success: function (res) {
        if (res.success) {
          if (thisController._isMounted) {
            thisController.setState({ recaptchaVerified: true });
          }
          thisController.setState(thisController.state);
        } else {
          thisController.captcha.reset();
          logout();
        }
      },
    });
  };

  handleChangeForInputs = ({ target }) => {
    let fields = this.state.fields;
    fields[target.name] = target.value;
    this.setState({
      fields,
    });
    this.validateFormInputs();
  };

  heartBeatApi = () => {
    let loginController = this;
    $.ajax({
      url: "/api/app/heartbeat",
      type: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success) {
          loginController.state.expiryTime =
            loginController.state.expiryTime - 300;
          loginController.setState(loginController.state);
        } else {
          logout();
        }
      },
    });
  };

  refreshTokenApi = () => {
    let loginController = this;
    $.ajax({
      url: "/api/app/refresh-token",
      type: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success) {
          localStorage.setItem("access_token", " " + res.authToken);
          localStorage.setItem("expires_in", res.expires_in);
          loginController.state.expiryTime = res.expires_in;
          loginController.setState(loginController.state);
        } else {
          logout();
        }
      },
    });
  };

  signin = (e) => {
    let loginController = this;
    loginController.setState(loginController.state);
    e.preventDefault();
    if (loginController.validateFormInputs()) {
      if (loginController.state.recaptchaVerified) {
        loginController.state.showLoader = true;
        loginController.setState(loginController.state);
        let passwordVal = this.state.fields.password;
        let username = this.state.fields.username;
        loginController.signInAndFetchUserAccountInfo({
          username,
          passwordVal,
        });
      }
    }
  };

  signInAndFetchUserAccountInfo = ({ username, passwordVal }) => {
    var response = false;
    var loginController = this;
    let errors = {};
    $.ajax({
      url: "/my-jeeva-api/admin/login",

      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: { username: username, password: passwordVal },
      success: function (res, xhr) {
        if (xhr == "success") {
          console.log("Access_token", res.access_token);
          localStorage.setItem("access_token", res.access_token);
          localStorage.setItem("expires_in", res.expires_in);
          localStorage.setItem("homeEntityName", res.homeEntityName);
          localStorage.setItem("currentScope", res.roleScopeValue);
          window.SCOPE_VALUE.CURRENT = res.roleScopeValue;
          localStorage.setItem("login_data", JSON.stringify(res));
          response = loginController.userAccount();
        } else {
          loginController.state.showLoader = false;
          loginController.state.errors["response"] =
            "Invalid Username/Password";
          loginController.state.resetPwdMsg = false;
          loginController.setState(loginController.state);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          loginController.state.showLoader = false;
          loginController.state.errors["response"] =
            "Invalid Username/Password";
          loginController.state.resetPwdMsg = false;
          loginController.setState(loginController.state);
        }
      },
    });
  };

  userAccount = () => {
    var loginController = this;
    let errors = {};
    $.ajax({
      url: "/my-jeeva-api/user-account/me",
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          localStorage.setItem(
            "user_details",
            JSON.stringify(res.result.userDetails)
          );
          localStorage.setItem(
            "user_roles",
            JSON.stringify(res.result.userRoles)
          );
          loginController.state.expiryTime = localStorage.getItem("expires_in");
          loginController.state.showLoader = false;
          loginController.setState(loginController.state);
          loginController.props.history.push("/projectmgmt");
        } else {
          loginController.state.showLoader = false;
          loginController.state.errors["response"] =
            "Invalid Username/Password";
          loginController.state.resetPwdMsg = false;
          loginController.setState(loginController.state);
        }
      },
    });
  };

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }
  fetchAllProjectsApi = () => {
    var projectResponse = false;
    $.ajax({
      url: "/api/project",

      method: "GET",
      data: {
        userId: JSON.parse(localStorage.getItem("user_details"))["userId"],
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            projectResponse = true;
          } else {
            projectResponse = false;
          }
        }
      },
    });
    return projectResponse;
  };

  validateFormInputs = () => {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["username"]) {
      formIsValid = false;
      errors["username"] = "*Please enter your registered Email ID";
    }

    if (typeof fields["username"] !== "undefined") {
      var pattern = new RegExp(
        /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/
      );
      if (!pattern.test(fields["username"])) {
        formIsValid = false;
        errors["username"] = "*Please enter valid Email ID";
      }
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  };

  showPassword = () => {
    if (this.state.showPwd) {
      this.setState({ showPwd: false });
    } else {
      this.setState({ showPwd: true });
    }
  };
  resetInput = () => {
    document.getElementById("password").value = "";
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.signin(e);
    }
  };

  render() {
    return (
      <div className="wrapper">
        <ToastContainer className="Toast-at-center" />
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        <link rel="stylesheet" href="assets/css/responsive.css" />
        <link rel="stylesheet" href="assets/css/responsive.css" />
        <link rel="stylesheet" href="assets/css/adminlte.css" />
        <link rel="stylesheet" href="assets/css/styles.css" />
        <div className="row col-md-12 p-0 m-0">
          <div className="col-md-5">
            <form className="form-horizontal">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-12 p-0">
                    <div
                      className="card sign-in-right-tab"
                      style={{ width: "100%" }}
                    >
                      <div className="card-body sign-in-page">
                        <div className="col-sm-12">
                          <div className="logoBox">
                            <img src="./assets/images/jeeva-logo.svg" alt="" />
                            <h5
                              className="signinTitle"
                              style={{ color: "#0270c0" }}
                            >
                              MyJEEVA Provider Portal
                            </h5>

                            <div
                              className="errorMsg"
                              style={{
                                color: this.state.resetPwdMsg
                                  ? "#b2beb5"
                                  : "red",
                              }}
                              name="response"
                            >
                              {this.state.resetPwdMsg ? (
                                <label>
                                  Your password has been reset successfully
                                  <br />
                                  New password sent to your mail
                                </label>
                              ) : (
                                this.state.errors.response
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="card-body">
                            <div className="col-9 p-0 mx-auto ">
                              <div
                                className="input-group mb-3"
                                style={{ width: "31vw" }}
                              >
                                <input
                                  type="email"
                                  className="login-form"
                                  name="username"
                                  id="userName"
                                  value={this.state.username}
                                  onChange={this.handleChangeForInputs}
                                  placeholder="Email ID"
                                />
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {this.state.errors.username}
                                </div>
                              </div>
                              <div className="input-group mb-3 passwordInput">
                                <input
                                  type={
                                    this.state.showPwd ? "text" : "password"
                                  }
                                  className="form-control sign-in- passinput"
                                  name="password"
                                  id="password"
                                  value={this.state.password}
                                  onChange={this.handleChangeForInputs}
                                  placeholder="Password"
                                  aria-label="Dhee password"
                                  onKeyDown={this.handleKeyDown}
                                />
                                <button
                                  className="btn showPassbtn"
                                  type="button"
                                  onClick={this.showPassword}
                                >
                                  {this.state.showPwd ? "Hide" : "Show"}
                                </button>

                                {/* <div className="input-group-append">
                                  <button className="btn showPassbtn" type="button" onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button> */}
                                {/* <button className="btn showPassbtn" type="button" onClick={this.resetInput} id='resetInput'>Reset</button> */}

                                {/* </div> */}
                              </div>
                              <div
                                className="fpass col-12 p-0"
                                style={{ textAlign: "left" }}
                              >
                                <Link to="/forgotpassword">
                                  {" "}
                                  Forgot/Reset Password
                                </Link>
                              </div>{" "}
                              <br />
                              {this.state.recaptchaLoaded && (
                                <ReCaptcha
                                  ref={(el) => {
                                    this.captcha = el;
                                  }}
                                  render="explicit"
                                  sitekey="6Lda-PoUAAAAAJcNRvLXI827ygaCcUIqA5r-wefu"
                                  onloadCallback={this.onLoadRecaptcha}
                                  verifyCallback={this.verifyCallbackApi}
                                />
                              )}
                              <br />
                              <br />
                              <div className="card-footera">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-block"
                                  onClick={this.signin}
                                >
                                  Sign In
                                </button>
                                {this.state.showLoader && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      paddingLeft: "10vw",
                                    }}
                                  >
                                    <div className="loader"></div>
                                  </div>
                                )}
                              </div>
                              <div className="input-group mb-3 ">
                                <div className="fpass col-12 p-0">
                                  {/* <span style={{ color: '#b7b4c0' }}>New here?</span>
                                  <Link to="/signup/step1"> Create an account</Link> */}
                                </div>
                              </div>
                            </div>
                          </div>

                          {this.state.recaptchaLoaded && <CookieConsentModal />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-7 sign-in-form-bg" />
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// src/my-jeeva/login/LoginPage.js